export const FINTEL_CHECK_SETTINGS = {
  ENABLE: 'Enable Fintel Check',
  LOADING_TEXT: 'Updating Fintel Check Settings',
};
